module.exports = __webpack_public_path__ + "static/pin-purple-97978614fac94764da3b1ce393235d85.png";